import { hexToRgb } from '@mui/material/styles';

import {
  Theme,
} from '@mui/material/styles'

import {
  IStatus,
} from '../../types/utils'

import {
  STATUS_CREATED,
  STATUS_STARTED,
  STATUS_ERROR,
  STATUS_TIMEOUT,
  STATUS_COMPLETE,
} from '../../constants'

import { green, amber, blue } from '@mui/material/colors';

export const isRgb = (string: string) => /#?([0-9a-f]{6})/i.test(string)

// convert hex into rgba(r,g,b,alpha)
export const getAlpha = (color: string, alpha: number | string): string => {
  return hexToRgb(color)
    .replace(/^rgb/, 'rgba')
    .replace(/\)$/, `, ${alpha})`);
}

export type IStatusColorName =
  'info' |
  'created' |
  'error' |
  'loading' |
  'warning' |
  'success'

export type IStatusColors = Record<IStatusColorName, string>

export const getStatusColors = (theme: Theme): IStatusColors => {
  return {
    created: theme.palette.grey[500],
    success: green[600],
    warning: amber[700],
    loading: blue[700],
    error: theme.palette.error.dark,
    info: theme.palette.primary.dark,
  }
}

export const STATUS_COLOR_MAP: Record<IStatus, IStatusColorName> = {
  [STATUS_CREATED]: 'created',
  [STATUS_STARTED]: 'loading',
  [STATUS_ERROR]: 'error',
  [STATUS_TIMEOUT]: 'error',
  [STATUS_COMPLETE]: 'success',
}